module.exports = __webpack_public_path__ + "img/4.d31840c7.png";